/**
 * Breadcrumb for Hub user detail pages
 */

import React from 'react'
import { Link } from 'react-router-dom'

export default function HubUsersBreadcrumb({ currentLabel }) {
  return (
    <nav aria-label="Breadcrumb" className="mb-6 rounded-lg border border-gray-200 bg-white px-4 py-3 shadow-sm">
      <ol className="flex flex-wrap items-center gap-2 text-sm">
        <li>
          <Link
            to="/hub/settings"
            className="font-medium text-green-700 hover:text-green-800 hover:underline"
          >
            Users
          </Link>
        </li>
        <li aria-hidden="true" className="text-gray-400 select-none">
          /
        </li>
        <li
          className="font-semibold text-gray-900 truncate max-w-[min(100%,24rem)]"
          aria-current="page"
        >
          {currentLabel}
        </li>
      </ol>
    </nav>
  )
}
